/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LinkType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL'
}
